import React from "react";

const Render = (props, context) => {
  let goal = props.goal;
  let units = props.category.unidad || "kg";
  let unitsPre = "";
  if (props.category.unidad === "$") {
    unitsPre = "$";
    units = "";
  }
  
  return (
    <div>
      {(goal.quantity > 0) && (
        <div>
          <p>
            Objetivo: <span className="avenirL">{unitsPre} {goal.quantity} {units}</span>
          </p>
          <p>
            Alcanzado: <span className="avenirL">{unitsPre} {goal.quantityProgress} {units}</span>
          </p>
          <p> 
            Puntos obtenidos: <span className="avenirL">{(goal.quantityProgress >= goal.quantity ? goal.quantityPoints : 0)} pts</span>
          </p>
        </div>
      )}
    </div>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Home/ObjetivoKilos.js